// import hooks
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components

// import assets

// import data

const WishItem = ({ item }) => {
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    return (
        <div
            className={`wishlist-item product-section-div ${
                windowWidth >= 992 ? "flex-between-row" : "flex-start-col"
            }`}
            key={item.id}
        >
            <div className="wish-item-txt flex-start-row">
                <div className="delete-svg ocean-svg red-svg"></div>
                <img
                    src={item.img}
                    alt="item image"
                    className="wish-item-img"
                />
                <div className="wishitem-txt-container">
                    <h2 className="wish-item-h">{item.name}</h2>
                    {item.store && (
                        <p className="wishlist-store flex-start-row">
                            <img src={item.storeFlag} alt="" />
                            <span>{item.store}</span>
                        </p>
                    )}
                    <p className="wishlist-counter">{`${t("account.count")} ${
                        item.count
                    }`}</p>
                </div>
            </div>

            <div className="wish-item-btn-div">
                {/* this button won't ne active in first release */}
                {/* <button className="ocean-blanc-btn">
                    <div className="wallet-svg"></div>
                    <div className="blanc-btn-txt">{t("account.pay-now")}</div>
                </button> */}
                <button className="ocean-btn">
                    {t("account.add-to-cart")}
                </button>
            </div>
        </div>
    );
};

export default WishItem;
